@if (wifiProfiles()) {
  <div>
    <div>
      <select [(ngModel)]="selectedProfile"
              class="form-select mb-3">
        @for (profile of wifiProfiles(); track profile) {
          <option [ngValue]="profile">{{ profile.SSID_STR }}</option>
        }
      </select>
      @if (selectedProfile) {
        <ml-mdm-wifi-profile [wifiProfile]="selectedProfile"
                             [allowEditing]="false">
        </ml-mdm-wifi-profile>
      }
      <p class="text-end">
        <button class="btn btn-link px-0"
                (click)="showMore = !showMore">more</button>
      </p>
      <div [class.collapse]="!showMore">
        @if (selectedProfile) {
          <ml-mdm-configuration-payload [(payloadContent)]="selectedProfile"
                                        [mutate]="true">
          </ml-mdm-configuration-payload>
        }
        <ml-mdm-configuration-profile [configurationProfile]="configurationProfile()"
                                      (configurationProfileChange)="configurationProfile.set($event)"></ml-mdm-configuration-profile>
      </div>
    </div>
    @if (selectedProfile) {
      <ml-mdm-command-spinner [commandProgress]="commandProgress()"
                              [small]="true"
                              [direction]="'right'"
                              [reverse]="true">
        <button type="button"
                class="btn btn-primary"
                (click)="installPreset()">Install</button>
      </ml-mdm-command-spinner>
    }
  </div>
} @else if (wifiProfiles()?.length === 0) {
  <div class="alert alert-secondary"
       role="alert">No WiFi profile presets available</div>
}